import { render, staticRenderFns } from "./TaggerCheck.vue?vue&type=template&id=38be0a7a&scoped=true"
import script from "./TaggerCheck.vue?vue&type=script&lang=js"
export * from "./TaggerCheck.vue?vue&type=script&lang=js"
import style0 from "./TaggerCheck.vue?vue&type=style&index=0&id=38be0a7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38be0a7a",
  null
  
)

export default component.exports